<template>
    <div
        class="m-virtualList "
        :class="{ '--opened': opened }"
        ref="virtual-list"
    >
        <div
            class="m-virtualList__heading"
            :class="[
                {
                    '--opened': opened,
                    '--selected': selectedOptions.length,
                    '--floatTitle': floatTitle,
                    '--disabled': disabled
                }
            ]"
            @click="!disabled && toggleList()"
        >
            <span
                class="m-virtualList__title"
                :class="{
                    '--selected ': selectedOptions.length,
                    '--floatTitle': floatTitle
                }"
            >
                {{ label }}
            </span>
            <span
                v-if="selectedOptionText"
                v-show="selectedOptions.length"
                class="m-virtualList__selectedOptionText"
            >
                {{ selectedOptionLabel.toString() }}
            </span>
            <div v-else class="m-virtualList__label">
                <filter-label
                    v-show="selectedOptions.length"
                    :backgroundColor="backgroundColor"
                    :color="color"
                    :text="selectedOptionLabel.toString()"
                    style="min-width: 0; user-select: none"
                    @close="clearOption()"
                />
            </div>
        </div>
        <div class="m-virtualList__listWrapper" v-show="opened">
            <div class="m-virtualList__searcher" v-if="searcher">
                <input type="text" class="form-control" v-model="searchQuery" />
            </div>
            <ul class="m-virtualList__list">
                <transition name="fade-fast">
                    <div v-show="loading" class="m-virtualList__loaderWrapper">
                        <div class="m-virtualList__loader spinner-grow text-dark">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </transition>
                <li
                    class="m-virtualList__listItem"
                    :class="{
                        '--active': isAllOptionsSelected
                    }"
                    v-if="multi && allOption"
                    @click="selectAllOption"
                >
                    {{ allOptionLabelText }}
                </li>
                <li
                    v-for="(item, idx) in items"
                    v-text="item.label"
                    :key="idx"
                    class="m-virtualList__listItem"
                    :class="{
                        '--active': selectedOptions.includes(item.value)
                    }"
                    @click="selectOption(item.value)"
                />
                <li v-if="items && items.length === 0" class="m-virtualList__listItem">
                    {{ loading ? 'Trwa wczytywanie wyników' : 'Brak wyników' }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            opened: false,
            page: 1,
            searchQuery: '',
            selectedOptionLabel: '',
            isAllOptionsSelected: false
        }
    },
    props: {
        label: {
            type: String,
            default: 'Wybierz'
        },
        searcher: {
            type: Boolean,
            default: true
        },
        moduleName: {
            type: String,
            required: false
        },
        fetchAction: {
            type: String,
            required: false
        },
        getter: {
            type: String,
            required: false
        },
        multi: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        },
        floatTitle: {
            type: Boolean,
            default: false
        },
        selectedOptionText: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        allOption: {
            type: Boolean,
            default: false
        },
        allOptionLabelText: {
            type: String,
            required: false
        },
        options: {
            type: Array,
            required: false
        },
        fetchOnInit: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        const listElm = this.$el.querySelector('.m-virtualList__list')
        listElm.addEventListener('scroll', e => {
            // Threshold protects against rounding errors at different zoom levels (110%, 125%, etc.)
            // Math.ceil ensures decimal scroll values are rounded up to catch the bottom
            const threshold = 2
            if (
                Math.ceil(listElm.scrollTop + listElm.clientHeight) >= listElm.scrollHeight - threshold
            ) {
                this.loadOptions()
            }
        })

        document.addEventListener('click', e => {
            if (this.opened && !this.$el.contains(e.target)) {
                this.closeList()
            }
        })
        this.$el.querySelector('.a-filterLabel') &&
            this.$el
                .querySelector('.a-filterLabel')
                .addEventListener('click', e => {
                    e.stopPropagation()
                })

        if (!this.fetchOnInit) {
            this.page++
        }

        this.setOptionLabel()
    },
    methods: {
        loadOptions() {
            if (!this.fetchAction && !this.moduleName) {
                return
            }

            const dispatchName = this.fetchAction
                ? this.fetchAction
                : `${this.moduleName}FetchForFilters`

            this.loading = true
            this.$store.dispatch(dispatchName, {
                page: this.page,
                query: this.searchQuery || null
            }).then(() => {
                this.page++
            }).finally(() => {
                this.loading = false
            })
        },
        async selectOption(val) {
            if (!this.multi) {
                await this.$emit('change', val)
                this.toggleList(false)
            } else {
                let selected = this.selectedOptions
                if (this.selectedOptions.includes(val)) {
                    selected = this.selectedOptions.filter(el => el !== val)
                } else {
                    selected.push(val)
                }
                await this.$emit('change', selected)
            }
        },
        clearOption() {
            this.$emit('change', this.multi ? [] : null)
        },
        toggleList(val) {
            typeof val === 'boolean'
                ? (this.opened = val)
                : (this.opened = !this.opened)
        },
        closeList() {
            if (this.opened) {
                this.opened = false
            }
        },
        setOptionLabel() {
            if (this.items && this.items.length) {
                if (this.selectedOptions && this.selectedOptions.length === 1) {
                    this.selectedOptionLabel = this.items.find(
                        // eslint-disable-next-line eqeqeq
                        el => el.value == this.selectedOptions[0]
                    ).label
                } else {
                    this.selectedOptionLabel = this.selectedOptions.length
                }
            }
        },
        async selectAllOption() {
            if (this.isAllOptionsSelected) {
                await this.$emit('change', [])
            } else {
                await this.$emit(
                    'change',
                    this.items.map(v => v.value)
                )
            }
            this.isAllOptionsSelected = !this.isAllOptionsSelected
        }
    },
    watch: {
        searchQuery() {
            this.page = 1
            this.loadOptions()
        },
        $attrs() {
            if (this.$attrs && this.$attrs.value === null) {
                this.selectedOptions = []
            }
        },
        items() {
            this.setOptionLabel()
        },
        selectedOptions() {
            if (this.selectedOptions.length) {
                this.setOptionLabel()
            }
        },
        fetchOnInit: {
            immediate: true,
            handler() {
                if (this.fetchOnInit) {
                    this.loadOptions()
                }
            }
        }
    },
    computed: {
        items() {
            if (this.options) {
                return this.options
            }

            if (this.getter) {
                return this.$store.getters[this.getter]
            }

            const getterName = `get${this.moduleName.charAt(0).toUpperCase() +
                    this.moduleName.slice(1)}ForFilters`

            return this.$store.getters[getterName]
        },
        selectedOptions: {
            get() {
                if (this.$attrs?.value) {
                    return Array.isArray(this.$attrs.value)
                        ? this.$attrs.value
                        : [this.$attrs.value]
                } else {
                    return []
                }
            },
            set() {}
        }
    }
}
</script>

<style lang="scss" scoped>
.m-virtualList {
    --padding: 0 8px 0 1.5rem;
    display: block;
    position: relative;
    width: 100%;
    min-height: 47px;
    text-align: left;
    font-size: 14px;
    z-index: 1;

    &.--opened {
        z-index: 2;
    }

    &__heading {
        min-height: 47px;
        padding: var(--padding);
        background: #fff
            url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e%3cpath fill='rgb(21, 90, 48)' d='M12 13.042L16.667 9 18 10.803 12 16l-6-5.197L7.333 9 12 13.042z'/%3e%3c/svg%3e")
            no-repeat right 0.8125rem center/24px 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 2.5rem;
        border: 1px solid var(--color-gray-200);
        border-radius: 5px;
        display: flex;
        align-items: center;
        box-shadow: var(--box-shadow);
        gap: 0.5rem;
        justify-content: space-between;

        &.--disabled {
            background: var(--color-gray-200)
                url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e%3cpath fill='%23041E42' d='M12 13.042L16.667 9 18 10.803 12 16l-6-5.197L7.333 9 12 13.042z'/%3e%3c/svg%3e")
                no-repeat right 0.8125rem center/24px 24px;
            cursor: not-allowed;
        }

        &.--opened {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom: 1px solid transparent;
        }

        &.--selected {
            span {
                user-select: none;
                max-width: 50%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }
        &.--floatTitle {
            overflow: visible;
            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 100%;
            }
        }
    }

    &__title {
        transition: 0.2s;

        &.--selected {
            &.--floatTitle {
                position: absolute;
                left: 7px;
                top: -10px;
                font-size: 0.75rem;
                background: #fff;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
            }
        }
    }

    &__selectedOptionText {
        color: #000;
        position: relative;
        left: -9px;
    }

    &__listWrapper {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        border-top: 0;
        border-left: 1px solid var(--color-gray-200);
        border-right: 1px solid var(--color-gray-200);
        border-bottom: 1px solid var(--color-gray-200);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        background: var(--color-white);
    }

    &__list {
        margin: 0;
        padding: 0;
        border: 0;
        overflow: auto;
        max-height: 300px;
        list-style: none;
        position: relative;
        border-radius: 4px;
    }

    &__listItem {
        background: var(--color-white);
        padding: 12px 16px;
        user-select: none;

        &.--active {
            background: var(--color-gray-200);
        }

        &:hover {
            cursor: pointer;
            background: var(--color-gray-300);
        }
    }

    &__searcher {
        padding: 8px 1rem 8px 1rem;
    }

    &__loaderWrapper {
        position: sticky;
        top: 50%;
        left: 0;
        bottom: 0;
        right: 0;
    }

    &__loader {
        --loader-size: 2.75rem;
        position: absolute;
        width: var(--loader-size);
        height: var(--loader-size);
        top: calc(50% - (var(--loader-size) / 2));
        left: calc(50% - (var(--loader-size) / 2));
    }

    &__label {
        min-width: 0;
        max-width: max-content;
        flex: 1;
    }

    .a-icon {
        position: absolute;
        top: 50%;
        right: 2.25rem;
        transform: translateY(-50%);
        cursor: pointer;
    }

    .form-control {
        height: calc(0.75rem + 1.625rem + 3px);
    }
}
</style>

<style lang="scss">
.m-virtualList {
    &__heading {
        span {
            user-select: none;
        }
    }
}
</style>
